export const pairingTypes = {
  INITIAL: "INITIAL",
  DEVICES: "DEVICES",
  OUR_FAMILY: "OUR_FAMILY",
  OUR_FAMILY_CREATE: "OUR_FAMILY_CREATE",
  THEIR_FAMILY: "THEIR_FAMILY",
  THEIR_FAMILY_CREATE: "THEIR_FAMILY_CREATE"
};

export const pairingResults = {
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  PAIRING_IN_PROGRESS: "PAIRING_IN_PROGRESS",
  EXCEEDED_DEVICE_LIMIT: "EXCEEDED_DEVICE_LIMIT"
};

export const pairingSources = {
  AUTO_PAIRING: "AUTO_PAIRING",
  MANUAL_PAIRING: "MANUAL_PAIRING"
};

export const pairingPromotions = {
  HOTEL_TABLET: "hotelTablet"
};
